import { render } from "./create.vue?vue&type=template&id=012378c0"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
script.render = render

export default script